import * as React from "react";
import { Intent, Spinner } from "@blueprintjs/core";
import "./PlaceholderEmbeddedPDF.css";
import { isLoading, loading, Loading } from "../../Loading";
import { Document, Page, pdfjs } from "react-pdf";
import { delay } from "../../system/delay";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface PlaceholderEmbeddedPDFProps {
    pdfUrl: string;
    containerElementId: string;
    widthScale?: number;
}

export interface PlaceholderEmbeddedPDFState {
    numPages: number | Loading;
    pageNumber: number;
    numLoadedPages: number;
}

export class PlaceholderEmbeddedPDF extends React.Component<PlaceholderEmbeddedPDFProps, PlaceholderEmbeddedPDFState> {
    constructor(props: PlaceholderEmbeddedPDFProps) {
        super(props);
        this.asyncConstructor(props);
        this.state = {
            pageNumber: 1,
            numLoadedPages: 0,
            numPages: loading()
        };
    }

    async asyncConstructor(props: PlaceholderEmbeddedPDFProps) {
        // Kombina so other components will mount
        // TODO figure out how to get rid of this
        await delay(1);
        const containerElement = document.getElementById(props.containerElementId);
        if (containerElement === null) {
            throw new Error("Bad element id");
        }

        if (this.props.widthScale !== undefined) {
            this.pageWidth = containerElement.clientWidth * this.props.widthScale;
        } else {
            // 95% of the document size
            this.pageWidth = containerElement.clientWidth * 0.95;
        }
    }

    private pageWidth = 0;

    onDocumentLoad = ({ numPages }: any) => {
        this.setState({ numPages: numPages });
    }

    renderPages(numPages: number) {
        let toReturn = [];
        for (let i = 0; i <= this.state.numLoadedPages; i++) {
            toReturn.push(
                <div className={"PlaceholderEmbeddedPDF__page"} key={i}>
                    {i + 1} / {numPages}
                    <Page
                        renderTextLayer={false}
                        pageNumber={i + 1}
                        width={this.pageWidth}
                        loading={"Loading..."}
                        onRenderSuccess={() => {
                            if (this.state.numLoadedPages < numPages - 1) {
                                // Load the pages one by one
                                this.setState(prevState => ({ numLoadedPages: prevState.numLoadedPages + 1 }));
                            }
                        }}
                    />
                </div>
            );
        }

        return <div className={"PlaceholderEmbeddedPDF__pageContainer"}>{toReturn.map(page => page)}</div>;
    }

    render() {
        return (
            <div>
                <Document
                    file={this.props.pdfUrl} // FOR DEV USE: "https://crossorigin.me/" +
                    loading={
                        <div className={"DocumentOverlayContentComponent_loadingContainer"}>
                            <Spinner
                                intent={Intent.PRIMARY}
                                className={"DocumentOverlayContentComponent_loadingSpinner"}
                            />
                        </div>}
                    onLoadSuccess={this.onDocumentLoad}
                >
                    {isLoading(this.state.numPages) ? "Loading..." : this.renderPages(this.state.numPages)}
                </Document>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/placeholders/PlaceholderEmbeddedPDF.tsx